import { useEffect } from 'react'
import {
    getActionsFromType,
    getMessageFromType,
    getNotificationType,
    openNotificationWithIcon,
} from '../utils/notification.helper'
import getConfig from '../configs/config'
import { useDispatch, useSelector } from 'react-redux'
import userSelectors from '../store/selectors/user.selectors'
import { NOTIFICATION_TYPES } from '../constants/notification-types'
import baseApi from '../store/apis/base.api'
import { normalizeNotification } from '../store/apis/utils/normalizers/notification.api.normalizers'

const useNotificationChannel = () => {
    const userId = useSelector(userSelectors.id)
    const dispatch = useDispatch()

    useEffect(() => {
        if (userId) {
            let websocketUrl
            let apiBaseUrl = getConfig().apiBaseUrl
            if (apiBaseUrl.includes('localhost')) {
                websocketUrl = `ws://${apiBaseUrl.replace(/http:?\/\//, '')}/notifications/${userId}`
            } else {
                websocketUrl = `wss://${apiBaseUrl.replace(/https:?\/\//, '')}/notifications/${userId}`
            }

            const ws = new WebSocket(websocketUrl)
            ws.onmessage = event => {
                const response = JSON.parse(event.data)
                const newNotifications = response.data.map(notification => normalizeNotification(notification))
                dispatch(
                    baseApi.util.updateQueryData('fetchNotifications', undefined, draft => {
                        if (draft && draft.notifications) {
                            const mergedNotifications = newNotifications
                                .concat(draft.notifications)
                                .reduce((acc, curr) => {
                                    if (!acc.some(item => item.id === curr.id)) {
                                        acc.push(curr)
                                    }
                                    return acc
                                }, [])

                            draft.notifications = mergedNotifications
                            draft.totalUnread += newNotifications.length
                        }
                    }),
                )

                newNotifications.map(notification =>
                    notification.type === NOTIFICATION_TYPES.ACTION
                        ? openNotificationWithIcon(
                              getNotificationType(notification.type),
                              getMessageFromType(notification.payload.action, notification.payload),
                              undefined,
                              undefined,
                              getActionsFromType(notification.payload?.action, notification.payload),
                          )
                        : openNotificationWithIcon(getNotificationType(notification.type), notification.message),
                )
            }

            return () => ws.close()
        }
    }, [userId])
}

export default useNotificationChannel
